import React from 'react';
import { bindActionCreators } from 'redux';
import * as adminActionCreator from '../../actions/admin';
import * as commonActionCreator from '../../actions/common';
import { connect } from 'react-redux';
import {Table, Column, Cell} from 'fixed-data-table';
import {Panel,Button} from 'react-bootstrap';
import _ from 'lodash';
import moment from 'moment';
import ResponsiveFixedDataTable from "../../components/ResponsiveFixedDataTable";
import AddConfidentialDocument from './AddConfidentialDocument';
import ConfirmDeleteConfidentialDoc from "./ConfirmDeleteConfDoc"

class PHS extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            columnWidths: {
                document: 380,
                createdAt: 170,
                addedBy: 170,
                action: 250
                
              },
              colSortDirs: {},
            hasCheckedPHS: false,
            hasCheckedConfidentialNotes: false,
            hasError: false
        };

        this.showConfidentialNotes.bind(this);
        this.showPHS.bind(this);
        this.showRPMSummary.bind(this);
    }

   
    componentDidMount() {
        let selectedPatient = this.props.selectedPatient;

        if (!selectedPatient) {
            this.showErrorMessage('Unknown Patient', 'Patient Details aren\'t Available. Please Refresh the Page or Try Again Later.');
            this.setState({hasCheckedPHS: true, hasCheckedConfidentialNotes: true, hasError: true});
        } else {
            // this.props.adminActions.getPHSAvailability(selectedPatient.id, hasError => this.setState({hasCheckedPHS: true, hasError: hasError}));
            // if(this.props.loadNoteNeeded){
            //     this.props.adminActions.getConfidentialNotesAvailability(selectedPatient.id, hasError => this.setState({hasCheckedConfidentialNotes: true, hasError: hasError}));
            // }
            this.props.adminActions.getConfidentialDocs(selectedPatient.id, hasError => this.setState({hasCheckedPHS: true, hasError: hasError}));
        }
    }

    handleColumnResize = (columnWidth, columnKey) => {
        this.setState({
          columnWidths: {
            ...this.state.columnWidths,
            [columnKey]: columnWidth,
          },
        });
      };

    showErrorMessage(title, message){
        this.props.commonActions.showToast({
            status: 'error',
            title: title,
            message: message
        });
        var interval = setInterval(()=> {
            clearInterval(interval);
            this.props.commonActions.hideToast();
        }, 2);
    }

    showPHS() {
        let selectedPatient = this.props.selectedPatient;

        if (!selectedPatient) {
            this.showErrorMessage('Unknown Patient', 'Patient Details aren\'t Available. Please Refresh the Page or Try Again Later.');
        } else {
            this.props.adminActions.getPHSPdf(selectedPatient.id, hasError => {
                if (!hasError) {
                  const newWindow = window.open(this.props.phsPdfUrl, '_blank');
                  if(newWindow) {
                    // Show popup block error, if window.open is null/undefined
                    newWindow.focus();
                  }else{
                    this.showErrorMessage('Error','Please disable popup blocker to download PHS ');
                  }
                }
            });
        }
    }

    showRPMSummary() {
        let selectedPatient = this.props.selectedPatient;

        if (!selectedPatient) {
            this.showErrorMessage('Unknown Patient', 'Patient Details aren\'t Available. Please Refresh the Page or Try Again Later.');
        } else {
            this.props.adminActions.getRPMSummaryPdf(selectedPatient.id, hasError => {
                if (!hasError) {
                  const newWindow = window.open(this.props.rpmSummaryPdfUrl, '_blank');
                  if(newWindow) {
                    // Show popup block error, if window.open is null/undefined
                    newWindow.focus();
                  }else{
                    this.showErrorMessage('Error','Please disable popup blocker to download RPM Summary ');
                  }
                }
            });
        }
    }

    showConfidentialNotes() {
        let selectedPatient = this.props.selectedPatient;

        if (!selectedPatient) {
            this.showErrorMessage('Unknown Patient', 'Patient Details aren\'t Available. Please Refresh the Page or Try Again Later.');
        } else {
            this.props.adminActions.getConfidentialNotesPdf(selectedPatient.id, hasError => {
                if (!hasError) {
                  const newWindow = window.open(this.props.confidentialNotesPdfUrl, '_blank');
                  if(newWindow) {
                    // Show popup block error, if window.open is null/undefined
                    newWindow.focus();
                  }else{
                    this.showErrorMessage('Error','Please disable popup blocker to download PHS ');
                  }
                }
            });
        }
    }

    handleAddDocument() {
        this.props.showSecondaryTimer();
        this.setState({ show:true });
    }

    onPopupHide() {
        this.props.showSecondaryTimer();
        this.setState({show: false});
    }

    onComfirmPopupHide() {
        this.setState({showConfirmDelete: false, docId:null});
    }

    onDownloadDoc(documentObject){
        console.log(documentObject);
        if(documentObject.file_type == "CONFIDENTIAL_FILE"){
            this.props.adminActions.downloadConfidentialDoc(this.props.selectedPatient.id,documentObject.id,(data) => {
                if(data.exists){
                    const newWindow = window.open(data.link, '_blank');
                    if(newWindow) {
                      // Show popup block error, if window.open is null/undefined
                      newWindow.focus();
                    }else{
                      this.showErrorMessage('Error','Please disable popup blocker to download PHS ');
                    }
                }
            })
        }else if(documentObject.file_type == "CONFIDENTIAL_NOTES"){
            this.showConfidentialNotes();
        }else if(documentObject.file_type == "PHS"){
            this.showPHS();
        }else if(documentObject.file_type == "RPM_SUMMARY"){
            this.showRPMSummary();
        }
    }

    showDeleteDoc(docId) {
        this.setState({showConfirmDelete: true, docId});
    }

    onDeleteConfirm(){
        this.props.adminActions.deleteConfidentialDoc(this.props.selectedPatient.id,this.state.docId);
    }


    render() {
        const { columnWidths, colSortDirs } = this.state;
        let { hasCheckedPHS } = this.state;
        const { confidentialDocs } = this.props;
        
        const header =
        <div style={{height:35}}>
            <div style={{fontSize:18,float:'left'}}>Documents</div>
            {
                this.props.isTriageUser && <div style={{float:'right',marginRight:10}}>
                <Button bsStyle="success" id="addGoalButton" onClick={ this.handleAddDocument.bind( this )}>Add Confidential Document</Button>
            </div>
            }
            
        </div>;
        return (
            <div>
                <Panel header={header}>
                <div style={{ height:300, position: "relative" }}>
                {
                   !hasCheckedPHS ? <div><i>Loading Documents...</i></div> 
                    : hasCheckedPHS && (!confidentialDocs || confidentialDocs.length === 0) ?  
                        <div>No Document Available.</div>
                    :
                        <ResponsiveFixedDataTable
                            rowHeight={50}
                            headerHeight={50}
                            isColumnResizing={false}
                            rowsCount={confidentialDocs.length}
                            onColumnResizeEndCallback={this.handleColumnResize}
                            width={800}
                            height={300}
                        >
                               <Column
                                columnKey="document"
                                fixed={true}
                                flexGrow={1}
                                isResizable={true}
                                width={columnWidths.document}
                                header={<Cell>Name</Cell>}
                                cell={({ rowIndex, data, columnKey, ...props }) => {
                                return <Cell {...props}>{
                                     confidentialDocs[rowIndex].file_type === 'CONFIDENTIAL_NOTES' ? "Confidential Note Summary" :
                                    confidentialDocs[rowIndex].file_name
                                }</Cell>;
                                }}
                            />
                            <Column
                                columnKey="createdAt"
                                fixed={true}
                                isResizable={true}
                                width={columnWidths.createdAt}
                                header={<Cell>Date</Cell>}
                                cell={({ rowIndex, data, columnKey, ...props }) => {
                                return <Cell {...props}>{
                                    moment(confidentialDocs[rowIndex].modified_date).format('MM/DD/YYYY hh:mm a')
                                    }</Cell>;
                                }}
                            />
                            <Column
                                columnKey="addedBy"
                                fixed={true}
                                isResizable={true}
                                width={columnWidths.addedBy}
                                header={<Cell>Added By</Cell>}
                                cell={({ rowIndex, data, columnKey, ...props }) => {
                                return <Cell {...props}>{
                                    confidentialDocs[rowIndex].added_by
                                }</Cell>;
                                }}
                            />
                            <Column
                                columnKey="action"
                                fixed={false}
                                align='center'
                                isResizable={true}
                                width={columnWidths.action}
                                header={<Cell></Cell>}
                                cell={({ rowIndex, data, columnKey, ...props }) => {
                                return <Cell {...props}>
                                     <Button bsStyle="primary" onClick={this.onDownloadDoc.bind(this,confidentialDocs[rowIndex])}>
                                            View
                                        </Button>
                                        {
                                            confidentialDocs[rowIndex].file_type === 'CONFIDENTIAL_FILE' && 
                                            <Button bsStyle="danger" style={{marginLeft: 15}} onClick={
                                                this.showDeleteDoc.bind(this, confidentialDocs[rowIndex].id)}>Delete</Button>
                                        }
                                    </Cell>;
                        }}
                    />
                        </ResponsiveFixedDataTable>
                }
                 <AddConfidentialDocument showSecondaryTimer={this.props.showSecondaryTimer}
                              onPopupHide={this.onPopupHide.bind(this)}
                              show={this.state.show}
                              onOptionSelect={this.props.onOptionSelect}/>
                 <ConfirmDeleteConfidentialDoc onPopupHide={this.onComfirmPopupHide.bind(this)} 
                    show={this.state.showConfirmDelete}
                    onDeleteConfirm= {this.onDeleteConfirm.bind(this) } />             
                </div>
                </Panel>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    'phsAvailable': state.levelTwoDashboard.phsAvailable,
    'phsPdfUrl': state.levelTwoDashboard.phsPdfUrl,
    'rpmSummaryAvailable': state.levelTwoDashboard.rpmSummaryAvailable,
    'rpmSummaryPdfUrl': state.levelTwoDashboard.rpmSummaryPdfUrl,
    'confidentialNotesAvailable': state.levelTwoDashboard.confidentialNotesAvailable,
    'documents':state.levelTwoDashboard.documents,
    'confidentialNotesPdfUrl': state.levelTwoDashboard.confidentialNotesPdfUrl,
    'confidentialDocs': state.levelTwoDashboard.confidentialDocs,
    selectedPatient: state.app.selectedPatient,
});

const mapDispatchToProps = (dispatch) => ({
    adminActions: bindActionCreators(adminActionCreator, dispatch),
    commonActions: bindActionCreators(commonActionCreator, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(PHS);